export enum LoginQueryParams {
  expired = "expired",
  invalid = "invalid",
  verified = "verified",
  accountActivated = "activated",
  passwordReset = "reset",
}
